//* Libraries imports
import { FaTrophy, FaEye } from "react-icons/fa";
import { motion } from "framer-motion"; 
import styles from "../styles/process-exam-actions.module.scss";

//* Components imports
import Icon from "../../../../../../components/common/Icon";

type ProcessExamActionsProps = {
  examId: string;
  onViewClick?: () => void;
  onResultsClick?: () => void;
  hideView?: boolean;
  hideResults?: boolean;
  hasResults?: boolean;
};

export function ProcessExamActions({
  onViewClick,
  onResultsClick,
  hideView = false,
  hideResults = false,
  hasResults = false,
}: ProcessExamActionsProps) {
  const buttonVariants = {
    hover: { scale: 1.1, transition: { duration: 0.2 } },
    tap: { scale: 0.9 },
  };

  return (
    <div className={styles.actionsContainer}>
      {/* Results Button - More prominent for candidates */}
      {onResultsClick && !hideResults && hasResults && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.resultsButton}`}
          onClick={onResultsClick}            title="Ver Meus Resultados"
          role="button"
          aria-label="Ver resultados da prova"
        >
          <Icon icon={FaTrophy} size={20} />
          <span className={styles.buttonText}>Resultados</span>
        </motion.div>
      )}

      {/* Quick View Button - Secondary action */}
      {onViewClick && !hideView && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.viewButton}`}
          onClick={onViewClick}            title="Visualizar detalhes"
          role="button"
          aria-label="Visualizar detalhes da prova"
        >
          <Icon icon={FaEye} size={16} />
        </motion.div>
      )}
    </div>
  );
}
